

    import { defineComponent, PropType } from 'vue';
    // PropType
    import { Promo } from '@/catalog-app/types';

    export default defineComponent({
        props: {
            promo: {
                type: Object as PropType<Promo>,
                required: true,
            }
        },
        setup() {
            return { }
        },
    });
